import { Fragment } from "react";
import { arrayOf, string } from "prop-types";
import * as R from "ramda";

const propTypes = {
  date: string,
  displayDate: string,
  authors: arrayOf(string),
};

const StoryMetadata = (props) => {
  const { date, displayDate } = props;

  const authors = R.compose(
    R.reject(R.isEmpty), // reject empty strings
    R.map(R.trim), // trim whitespace for display and for R.isEmpty check
    R.reject(R.isNil), // make sure we weren't passed [undefined]
    R.defaultTo([]),
    R.prop("authors"),
  )(props);

  const authorsNode = authors.length > 0 && (
    <span className="story-metadata__byline">
      by{" "}
      {authors.map((author, index, arr) => {
        return (
          <Fragment key={index}>
            {author}
            {arr.length - 1 !== index ? ", " : null}
          </Fragment>
        );
      })}
    </span>
  );

  const dateNode = date && displayDate && (
    <>
      <time className="story-metadata__date" dateTime={date}>
        {displayDate}
      </time>
    </>
  );

  return authorsNode || dateNode ? (
    <div className="story-metadata">
      {authorsNode}
      {authorsNode && dateNode && <> &mdash; </>}
      {dateNode}
    </div>
  ) : null;
};

StoryMetadata.propTypes = propTypes;
export default StoryMetadata;
